
import Swiper from 'https://unpkg.com/swiper@8/swiper-bundle.esm.browser.min.js';

class SwiperPlugin
{
	Carrosel_Home()
	{
		const TitleCarrossel = $('#BannerHomeSwiper .swiper-slide');
		const swiperNavControlls =
		{
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		};
		const swiperAutoplay = 
		{
			delay: 8000,
		}

		const swiper = new Swiper('#BannerHomeSwiper', 
		{
			slidesPerView: 1,
			spaceBetween: 0,
			speed: 1000,
			autoHeight: true,
			simulateTouch:TitleCarrossel.length > 1 ? true : false,
			loop: TitleCarrossel.length > 1 ? true : false,
			autoplay:TitleCarrossel.length > 1 ? swiperAutoplay : false,
			disableOnInteraction: false,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			}
		});

		$(window).on("resize", function()
		{
			swiper.update();
		});
	}

	Carrossel_Relacionados()
	{
		const settings = 
        {
            slidesPerView: 6,
            spaceBetween: 0,
            loop: false,
            navigation: {
                nextEl: '.CarrosselContainer .swiper-button-next',
                prevEl: '.CarrosselContainer .swiper-button-prev',
            },
            // pagination: {
            //     el: `#${parentID} .swiper-pagination`,
            //     clickable: true,
            // },
            breakpoints:
            {
                0: {
                    slidesPerView: "auto",
                    spaceBetween: 10,
                },
                568: {
                    slidesPerView: 4,
                    spaceBetween: 16,
                },
                1024: {
                    slidesPerView: 6,
                    spaceBetween: 24,
                }
            }
        };		

		const swiper = new Swiper('.CarrosselContainer .swiperRelacionados', settings);

		$(window).on("resize", function()
		{
			swiper.update();
		});
	}

	init(options)
	{
		let self = this;

		if ($("#BannerHomeSwiper").length > 0)
    		self.Carrosel_Home();
		
		if ($(".swiperRelacionados").length > 0)
    		self.Carrossel_Relacionados();
	}
}

export default SwiperPlugin;